// @flow

const initialState: Object = {
  isPlaying: false,
  hasFinished: false,
};

export default (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case 'INTRO_FINISHED':
      return {
        isPlaying: action.isPlaying,
        hasFinished: action.hasFinished,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./shared/state/reducers/intro.js